import Home from "../../Components/Main";
import Header from "../../Components/Header";
import ParticlesComponent from "../../Components/particles";

const PageHome = () => {
  return (
    <div>
      <ParticlesComponent />
      <Header />
      <Home />
    </div>
  );
};
export default PageHome;
